import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { SegmentMemberResponse } from '../../../models/segment.model';
import { SegmentService } from '../../../services/segment-api.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { DatetimePipe } from '../../../../../shared/pipe/datetime.pipe';

@Component({
  selector: 'app-segment-members-table',
  standalone: true,
  imports: [CommonModule, DatetimePipe],
  templateUrl: './segment-members-table.component.html',
})
export class SegmentMembersTableComponent implements OnChanges, OnDestroy {
  @Input() segmentId: number = 0;
  @Input() segmentType: 'STATIC' | 'DYNAMIC' = 'STATIC';
  @Output() segmentGone = new EventEmitter<void>();

  members: SegmentMemberResponse[] = [];
  isLoading = false;
  page = 0;
  readonly size = 20;
  totalElements = 0;
  totalPages = 0;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private segmentApi: SegmentService,
    private toast: ToastService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['segmentId'] && this.segmentId > 0) {
      this.reset();
      this.cargarMiembros();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private reset(): void {
    this.members = [];
    this.page = 0;
    this.totalElements = 0;
    this.totalPages = 0;
  }

  cargarMiembros(): void {
    if (!this.segmentId) return;
    this.isLoading = true;
    this.segmentApi.getMembers(this.segmentId, this.page, this.size)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.members = (res.content || []).filter(m => !m.isExcluded);
          this.totalElements = res.totalElements;
          this.totalPages = res.totalPages;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.isLoading = false;
          if (err?.status === 404) {
            this.segmentGone.emit();
          } else {
            this.toast.error({ title: 'Error', message: 'No se pudieron cargar los miembros del segmento.' });
          }
        },
      });
  }

  previousPage(): void {
    if (this.page > 0) {
      this.page--;
      this.cargarMiembros();
    }
  }

  nextPage(): void {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.cargarMiembros();
    }
  }
}
